/**
 * Tastaturnavigation für die Such-Autocomplete.
 *
 * Bewusst frei von DOM und Vue: die Funktionen werten nur aus und geben die
 * auszuführende Aktion zurück. Ausgeführt wird sie in der jeweiligen
 * Komponente (SearchAutocompleteDesktop.vue / SearchAutocompleteMobile.vue).
 *
 * Dateiendung .mjs, damit Node das Modul ohne "type": "module" in der
 * package.json als ESM lädt (`node --test`). Webpack löst die explizite
 * Endung im Import auf.
 */

export const NO_SELECTION = -1;

/**
 * Verschiebt die Auswahl um delta Positionen.
 *
 * Der Umlauf geht bewusst über NO_SELECTION: nach dem letzten Eintrag landet
 * man wieder im reinen Eingabefeld und kann per Enter die vollständige
 * Suchergebnisseite aufrufen.
 */
export function nextIndex(current, count, delta) {
    if (count <= 0) {
        return NO_SELECTION;
    }

    const position = current >= 0 && current < count ? current + 1 : 0;
    const next = (position + delta + count + 1) % (count + 1);

    return next === 0 ? NO_SELECTION : next - 1;
}

/**
 * Wertet ein keydown-Event aus.
 *
 * @returns {{type: 'move', index: number}|{type: 'select', index: number}|{type: 'close'}|null}
 *          null = Taste nicht behandelt, Default-Verhalten bleibt bestehen.
 */
export function keydownAction(event, state) {
    const count = state.count;
    const activeIndex = state.activeIndex;

    if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        if (count <= 0) {
            return null;
        }
        event.preventDefault();

        return {type: 'move', index: nextIndex(activeIndex, count, event.key === 'ArrowDown' ? 1 : -1)};
    }

    if (event.key === 'Enter') {
        // Ohne Auswahl bewusst nicht abfangen: das Formular submittet auf /search.
        if (activeIndex < 0 || activeIndex >= count) {
            return null;
        }
        event.preventDefault();

        return {type: 'select', index: activeIndex};
    }

    if (event.key === 'Escape') {
        if (count <= 0) {
            return null;
        }
        event.preventDefault();

        return {type: 'close'};
    }

    return null;
}
